export const PHOTOGRAPHY_STATUS = {
  PENDING   : 'pending',
  COMPLETED : 'completed'
}

export const PHOTO_UPLOAD_STATUS = {
  PENDING   : 'pending',
  COMPLETED : 'completed'
}

export const PHOTO_EDITED_STATUS = {
  PENDING   : 'pending',
  COMPLETED : 'completed'
}

export const PHOTO_CURATION_STATUS = {
  PENDING             : 'pending',
  ACCEPTED            : 'accepted',
  REQUIRE_PHOTOGRAPHY : 'require_photography',
  REQUIRE_PHOTO_EDIT  : 'require_photo_edit'
}

export const IS_THUMBNAIL = {
  YES : 'true',
  NO  : 'false'
}

export const LIVE_PROCESS_STATUS = {
  PENDING    : 'pending',
  DISABLED   : 'disabled',
  READY_LIVE : 'ready_live',
  COMPLETED  : 'completed'
}
